import { useMemo } from 'react'
import { Alert, Button } from '@mui/material'
import { com } from '@eidu/web'
import type { ColumnHeader } from './utils'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind

type UserTypesWithoutColumnWarningProps = {
  entityTypes: readonly EntityType[]
  columnHeaders: readonly ColumnHeader[]
  onGrantPermission: (typeId: string) => void
}

const UserTypesWithoutColumnWarning = ({
  entityTypes,
  columnHeaders,
  onGrantPermission,
}: UserTypesWithoutColumnWarningProps) => {
  const userTypesWithoutColumn = useMemo(
    () =>
      entityTypes
        .filter((t) => t.kind.equals(EntityTypeKind.Companion.User))
        .filter((t) => {
          const typeKey = `type:${t.id.toString()}`
          return !columnHeaders.some((col) => col.id === typeKey || col.parentKey === typeKey)
        }),
    [entityTypes, columnHeaders]
  )

  if (userTypesWithoutColumn.length === 0) return null

  return (
    <Alert
      severity="warning"
      action={
        <Button color="inherit" size="small" onClick={() => onGrantPermission(userTypesWithoutColumn[0].id.toString())}>
          Grant permission
        </Button>
      }
    >
      The following user type{userTypesWithoutColumn.length === 1 ? '' : 's'} ha
      {userTypesWithoutColumn.length === 1 ? 's' : 've'} no permission grants:{' '}
      {userTypesWithoutColumn.map((t) => String(t.name)).join(', ')}
    </Alert>
  )
}

export default UserTypesWithoutColumnWarning
